<template>

    <form ref="extratoescolabox-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">

            
                    <div class="form-group col-md-4">
                        <label for="escolaBoxId">Escola</label>
                        <select v-select="{ dataitem: 'Escola', default: 'Selecione' }" v-model="model.escolaBoxId" class="form-control" name="escolaBoxId" required></select>
                    </div>
					<div class="form-group col-md-4">
                        <label for="dataGeracao">Data de Geração</label>
                        <input type="text" v-datepicker class="form-control" name="dataGeracao" v-model="model.dataGeracao" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="dataVencimento">Data de Vencimento</label>
                        <input type="text" v-datepicker class="form-control" name="dataVencimento" v-model="model.dataVencimento" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="dataReferenciaInicio">Data Referência de</label>
                        <input type="text" v-datepicker class="form-control" name="dataReferenciaInicio" v-model="model.dataReferenciaInicio" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="dataReferenciaFim">Data Referência até</label>
                        <input type="text" v-datepicker class="form-control" name="dataReferenciaFim" v-model="model.dataReferenciaFim" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="valorLicencaUsoBox">Valor Licença Uso Box</label>
                        <input type="text" class="form-control" name="valorLicencaUsoBox" placeholder="ValorLicencaUsoBox" v-model="model.valorLicencaUsoBox" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="valorUnitarioEnvioSMS">Valor Unitário Envio SMS</label>
                        <input type="text" class="form-control" name="valorUnitarioEnvioSMS" placeholder="ValorUnitarioEnvioSMS" v-model="model.valorUnitarioEnvioSMS" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="quantidadeSMSExcedidos">Quantidade SMS Excedidos</label>
                        <input type="text" class="form-control" name="quantidadeSMSExcedidos" placeholder="QuantidadeSMSExcedidos" v-model="model.quantidadeSMSExcedidos" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="valorExcedidosEnvioSMS">Valor Excedidos Envio SMS</label>
                        <input type="text" class="form-control" name="valorExcedidosEnvioSMS" placeholder="ValorExcedidosEnvioSMS" v-model="model.valorExcedidosEnvioSMS" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="valorLicencaOnMaps">Valor Licença OnMaps</label>
                        <input type="text" class="form-control" name="valorLicencaOnMaps" placeholder="ValorLicencaOnMaps" v-model="model.valorLicencaOnMaps" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="valorUnitarioContratoTalk">Valor Unitario Contrato Talk</label>
                        <input type="text" class="form-control" name="valorUnitarioContratoTalk" placeholder="ValorUnitarioContratoTalk" v-model="model.valorUnitarioContratoTalk" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="quantidadeContratoTalkExcedidos">Quantidade Contrato Meu CNA</label>
                        <input type="text" class="form-control" name="quantidadeContratoTalkExcedidos" placeholder="QuantidadeContratoTalkExcedidos" v-model="model.quantidadeContratoTalkExcedidos" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="valorExcedidosContratoTalk">Valor Excedidos Meu CNA</label>
                        <input type="text" class="form-control" name="valorExcedidosContratoTalk" placeholder="ValorExcedidosContratoTalk" v-model="model.valorExcedidosContratoTalk" required />
                    </div>
					<div class="form-group col-md-4">
                        <label for="percentualDescontoLicencaUsoBox">% Desconto Licença Uso Box</label>
                        <input type="text" class="form-control" name="percentualDescontoLicencaUsoBox" placeholder="PercentualDescontoLicencaUsoBox" v-model="model.percentualDescontoLicencaUsoBox"  />
                    </div>
					<div class="form-group col-md-4">
                        <label for="percentualDescontoTotalEnvioSMS">% Desconto Total Envio SMS</label>
                        <input type="text" class="form-control" name="percentualDescontoTotalEnvioSMS" placeholder="PercentualDescontoTotalEnvioSMS" v-model="model.percentualDescontoTotalEnvioSMS"  />
                    </div>
					<div class="form-group col-md-4">
                        <label for="percentualDescontoLicencaOnMaps">% Desconto Licença OnMaps</label>
                        <input type="text" class="form-control" name="percentualDescontoLicencaOnMaps" placeholder="PercentualDescontoLicencaOnMaps" v-model="model.percentualDescontoLicencaOnMaps"  />
                    </div>
					<div class="form-group col-md-4">
                        <label for="percentualDescontoTotalContratoTalk">% Desconto Total Contrato Talk</label>
                        <input type="text" class="form-control" name="percentualDescontoTotalContratoTalk" placeholder="PercentualDescontoTotalContratoTalk" v-model="model.percentualDescontoTotalContratoTalk"  />
                    </div>
                    <div class="form-group col-md-4">
                        <label for="planoServicoId">Plano Servico </label>
                        <select v-select="{ dataitem: 'PlanoServico', default: 'Selecione' }" v-model="model.planoServicoId" class="form-control" name="planoServicoId"></select>
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "extratoescolabox-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {
                planoServicoId: ""
            },

            form: "extratoescolabox-form-edit",
            
            resources: {
                edit: 'extratoescolabox',
            },

        }),
		
        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false)return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ extratoEscolaBoxId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>